// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1827":"b1ccaae015376401","3404":"f4350d1113679764"}[chunkId] + ".css";
};